import React from "react";

export const EditAgentGuardContext = React.createContext<((action: () => void) => void) | null>(null);

export const useEditAgentGuard = () => {
    const guardNavigation = React.useContext(EditAgentGuardContext);
    return guardNavigation ?? ((action: () => void) => action());
};
